import { useComponentContext } from '../../ComponentContext'
import { ScanButton } from '@jsainsburyplc/retail-search-scanner'

interface ISubmitBarcode {
  id: string
  scanButton?: string
  closeButtonText?: string
}

function SubmitBarcode({ id, scanButton = 'Scan barcode', closeButtonText = 'Close' }: ISubmitBarcode) {
  const { handleNext } = useComponentContext()
  
  const onScan = ( code : any) => {
    handleNext({ id, value: code })
  }

  return(
    <ScanButton
      onScan={onScan}
      scanButtonText={scanButton}
      constraints={{ facingMode: 'environment' }}
      onInvalid={(errorMessage: string) => {
        console.error('Invalid barcode:', errorMessage)
      }}
      closeButtonText={closeButtonText}
    />
  )
}

export default SubmitBarcode
